import React, { memo, useState } from 'react';
import Button from '@mui/material/Button';
import ExpandMoreIcon from '@mui/icons-material/ExpandMoreRounded';
import { withStyles, withTheme } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Link from 'studio/components/Link';
import styles from './KnowledgeGraphSwitcher.styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import { KnowledgeGraphIcon } from 'components/Icons';
import classNames from 'classnames';
import { paths as studioPaths } from 'studio/App/Studio/Studio';
import Tooltip from '@mui/material/Tooltip';

const KnowledgeGraphSwitcher = ({ classes, knowledgeGraphs, knowledgeGraph, ...props }) => {
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const tooltip = 'Select the knowledge graph you want to configure and edit';

  return (
    <>
      <Tooltip title={tooltip} placement="right" arrow>
        <ListItem disablePadding>
          <ListItemButton
            className={classNames(classes.root, props.className)}
            onClick={open}
            data-test="knowledgeGraphSwitcher"
          >
            <ListItemIcon>
              <KnowledgeGraphIcon className={classes.kgIcon} />
            </ListItemIcon>
            <ListItemText primary={knowledgeGraph?.data.info.default.name || 'Select knowledge graph'} />
            <ListItemIcon>
              <ExpandMoreIcon color="disabled" className={classes.expandIcon} />
            </ListItemIcon>
          </ListItemButton>
        </ListItem>
      </Tooltip>

      <Dialog
        fullWidth
        maxWidth="sm"
        className={classes.dialog}
        open={isOpen}
        onClose={close}
        data-test="knowledgeGraphSwitcherDialog"
      >
        <DialogTitle>
          Select a Knowledge Graph
          <Button
            variant="contained"
            color="primary"
            component={Link}
            href={studioPaths.new}
            knowledgeGraph={knowledgeGraph}
            onClick={close}
          >
            Create new
          </Button>
        </DialogTitle>
        <List>
          {knowledgeGraphs.map(kg => (
            <ListItem key={kg.data.id} disablePadding>
              <ListItemButton
                dense
                color="inherit"
                selected={kg.data.id === knowledgeGraph?.data.id}
                component={Link}
                knowledgeGraph={kg}
                onClick={close}
              >
                <ListItemText primary={kg.data.info.default.name} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Dialog>
    </>
  );
};

export default memo(withTheme(withStyles(styles)(KnowledgeGraphSwitcher)));
